import { render, staticRenderFns } from "./Games1.container.vue?vue&type=template&id=7e94bae0&scoped=true&"
import script from "./Games1.container.vue?vue&type=script&lang=js&"
export * from "./Games1.container.vue?vue&type=script&lang=js&"
import style0 from "./Games1.container.vue?vue&type=style&index=0&id=7e94bae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e94bae0",
  null
  
)

export default component.exports